import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Stack } from '@mui/system';
import React, { useState, useEffect } from 'react';
import ContainedButton from '../../../components/actions/ContainedButton';
import ErrorAlert from '../../../components/alerts/ErrorAlert';
import InputForm from '../../../components/forms/InputForm';
import BaseModal from '../../../components/modals/BaseModal';
import useUser from '../../../hooks/api/useUser';
import useForm from '../../../hooks/useForm';
import { GENDERS, LANGUAGES, USER_TYPES } from '../../../utils/enums';
import moment from 'moment-timezone';
import InputSelectForm from '../../../components/forms/InputSelectForm';
import { catalogs } from '../../../utils/catalogs';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from '../../../routes/paths';
const AddUserModal = (props) => {

    const {open, onClose, onRefresh} = props
    const  classes = useStyles()
    const [sending, setSending] = useState(false)
    const [error, setError] = useState()
    const formManager = useForm(form_data)
    const userManager = useUser()
    const {form, onValidateForm, onGetFormData, onResetForm, onChangeForm} = formManager
    const navigate = useNavigate()

    useEffect(() => {
        if(open) onResetForm()
    },[open, onResetForm])

    const onSubmit = async() => {
        //console.log(form)
        const valid = onValidateForm(form)
            
        if(!valid){
            setError({message:'Debe llenar todos los campos solicitados'})
            return
        }

        let data2send = onGetFormData({removeEmptySpaces:true})

        data2send.zip = '03200'
        data2send.language_id = LANGUAGES.SPANISH
        data2send.timezone = moment.tz.guess()
        data2send.indigenous = 0
        data2send.user_type_id = USER_TYPES.ADMIN

        if(data2send.password !== data2send.passwordConfirmation){
            setError({message:'Las contraseñas no coinciden'})
            return
        }

        setSending(true)

        try {
            console.log('Send data', data2send)
            const id_user = await userManager.actions.onAdd(data2send)
            navigate(PATH_DASHBOARD.user.account(id_user))
            //console.log(response)
            await onRefresh()

        } catch (error) {
            setError(error)
            setSending(false)
            return
        }

        setSending(false)
        onClose()

    }

    return ( 
        <BaseModal maxWidth='sm'
        title='Nuevo usuario'
        open={open} 
        onClose={onClose} >
            <div>
                <Typography variant='body1' className={classes.description}>
                    Ingrese los datos solicitados para crear un nuevo usuario
                </Typography>
                <div>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <InputForm data={form.first_name} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputForm data={form.fathers_last_name} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputForm data={form.mothers_last_name} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputForm data={form.email} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputSelectForm data={form.user_gender_id} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputForm data={form.password} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputForm data={form.passwordConfirmation} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                {error && 
                                    <Grid item xs={12}>
                                        <ErrorAlert 
                                        error={error} 
                                        onClose={() => setError(null)} />
                                    </Grid> 
                                }
                                <Grid item xs={12}>
                                    <Stack direction='row' justifyContent='flex-end' >
                                        <ContainedButton  loading={sending} onClick={onSubmit}>
                                            Agregar
                                        </ContainedButton>
                                    </Stack>
                                    
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </BaseModal>
     );
}

const useStyles = makeStyles(theme => ({
    description:{
        marginBottom:16
    }
}))
 
export default AddUserModal;

const form_data = {
    first_name: {
        value:null,
        error: true,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'first_name',
            type: 'text',
            fullWidth: true,
            autoComplete:"new-password",
            label:'Nombre(s)',
            placeholder:'Nombre(s)',
            helperText:'Debe ser un valor entre 1 a 255 caracteres'
        },
        rules: {type: 'distance', min:1, max:255}
    },
    fathers_last_name: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'fathers_last_name',
            type: 'text',
            fullWidth: true,
            autoComplete:"new-password",
            label:'Apellido paterno',
            placeholder:'Apellido paterno',
            helperText:'Debe ser un valor entre 1 a 255 caracteres'
        },
        rules: {type: 'distance', min:1, max:255}
    },
    mothers_last_name: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config: {
            id: 'mothers_last_name',
            type: 'text',
            fullWidth: true,
            autoComplete:"new-password",
            label:'Apellido materno',
            placeholder:'Apellido materno',
            helperText:'Debe ser máximo de 255 caracteres'
        },
        rules: {type: 'distance', min:0, max:255}
    },
    email: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: true,
        config: {
            id: 'email',
            type: 'email',
            fullWidth: true,
            label:'Email',
            autoComplete:"new-password",
            placeholder:'Ingresa tu correo electrónico',
            helperText:'Correo no válido'
        },
        rules: {type: 'email'}
    },
    password: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: true,
        injectData:'passwordConfirmation',
        config: {
            id: 'password',
            type: 'password',
            fullWidth: true,
            label:'Contraseña',
            autoComplete:"new-password",
            placeholder:'Ingresa tu contraseña',
            helperText:'Contraseña incorrecta'
        },
        rules: {type: 'distance', min:1}
    },
    passwordConfirmation: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: true,
        compareTarget:'password',
        config: {
            id: 'passwordConfirmation',
            type: 'password',
            fullWidth: true,
            label:'Confirmar contraseña',
            placeholder:'Confirmar contraseña',
            helperText:'Las contraseñas no coinciden'
        },
        rules: {type: 'equals'}
    },
    user_gender_id: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[...catalogs.genders],
        config: {
            id: 'user_gender_id',
            type: 'select',
            fullWidth: true,
            autoComplete:"new-password",
            label:'Género',
            placeholder:'Género',
            helperText:'Debe seleccionar una opción'
        },
        rules: {type: 'none'}
    },
    

}